import type { ServiceContractDto } from '@api/machines'

export type CalculateOverAllowanceSplitParams = {
  itemPrice: number
  machineAndAttachmentTotal: number
  overAllowanceTotal: number
  serviceContract?: ServiceContractDto | null
}

export function calculateOverAllowanceSplit({
  itemPrice,
  machineAndAttachmentTotal,
  overAllowanceTotal
}: CalculateOverAllowanceSplitParams) {
  if (machineAndAttachmentTotal === 0 || itemPrice === 0) {
    return 0
  }

  return Math.round(
    (overAllowanceTotal * itemPrice) / machineAndAttachmentTotal
  )
}
